module.exports = __webpack_public_path__ + "img/3.d3dd6edb.jpg";